'use client';

import { createContext } from 'react';

interface InteractiveObjectLinkContextValue {
	activeKey: string;
	setActiveKey: (key: string) => void;
}

export const InteractiveObjectLinkContext =
	createContext<InteractiveObjectLinkContextValue | null>(null);
